import { useEffect, useRef } from 'react';

/**
 * ブラウザのタブ名 (document.title = サイト名称) を地区名にする hook。
 *
 * 要望「サイト名称は地区名にする」: `/m/:urlToken` で district が ready になったら、タブ名を
 * 地区名にする。PWA manifest 側 (`useDistrictManifest`) と同じく district 解決後に document
 * メタデータを地区別へ切り替える対の処理。
 *
 * 挙動:
 *   - `name` が空 / null / undefined のときは何もしない (解決前は静的 `<title>` のまま。
 *     issue #16 と同じく解決前に地区名・fallback を出さない)。
 *   - unmount or 地区変更時に元のタイトルへ復元 (SPA で `/m/:urlToken` を抜けたら静的 title に戻す)。
 */
export function useDocumentTitle(name: string | null | undefined): void {
  // 初回適用前の元タイトル (cleanup で復元)。render に影響しないため ref。
  const originalTitleRef = useRef<string | null>(null);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (!name) return;
    if (originalTitleRef.current === null) {
      originalTitleRef.current = document.title;
    }
    document.title = name;
    return () => {
      if (originalTitleRef.current !== null) {
        document.title = originalTitleRef.current;
        originalTitleRef.current = null;
      }
    };
  }, [name]);
}
